import { useQueryClient } from "react-query";

import { AlertConfirmationModal } from "../alert-confirmation-modal";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useDeleteFidelCard } from "../../../CustomHooks/Mutations";

import { dispatchAPIErrorToast, dispatchSuccessToast } from "../../../Utils/helpers";
import { APIQueryKeys, modalVariants } from "../../../Utils/constants";

export function renderDeleteFidelCard(modalContext, card) {
  const { updateModalComponent, pushModalStack, setModalVariant, setModalTitle, setModalClassName, setModalAriaLabel } = modalContext;

  updateModalComponent(() => <DeleteFidelCard card={card} />);
  pushModalStack(() => renderDeleteFidelCard(modalContext));
  setModalVariant(modalVariants.promptDialog);
  setModalTitle("");
  setModalAriaLabel?.("Delete card");
  setModalClassName("");
}

const DeleteFidelCard = ({ card }) => {
  const queryClient = useQueryClient();

  const { onModalClose, popModalStack } = useModalContext();

  const { isLoading: isDeletingFidelCard, mutate: DeleteFidelCard } = useDeleteFidelCard({
    onSuccess:  () => {
       queryClient.refetchQueries(APIQueryKeys.fidelCards);
       queryClient.refetchQueries(APIQueryKeys.fidelNearestLocations);
       queryClient.refetchQueries(APIQueryKeys.consumerDeals);
      popModalStack(1);
      dispatchSuccessToast("Card Removed Successfully",{ alignToAppContent: true });
    },
    onError: (err) => dispatchAPIErrorToast({ message: err?.response?.data?.error, key: "deleteFidelCard" }),
  });

  return (
    <AlertConfirmationModal
      title="Delete Card?"
      description={
        <>
          Are you sure you want to delete this card<br></br>({card?.card_type} ....{card?.card_last_4_digits})? Once
          you remove your card, you will no longer be able to participate in the program
        </>
      }
      CTAButtonText="Confirm"
      secondaryCTAButtonText="Cancel"
      onCTAButtonClick={() => DeleteFidelCard(card?.card_id)}
      onSecondaryCTAButtonClick={onModalClose}
      isCTALoading={isDeletingFidelCard}
    />
  );
};
